// Persist display fields only. Personal/address/emergency/dietary data stays in
// the page's scoped memory and must never enter the native display snapshot.
const fields = ['id','member_id','first_name','preferred_name','last_name','full_name','membership_number','profile_picture','profile_picture_url','profile_portrait_mode','preferred_locale','effective_locale','club_default_locale','golf_handicap','tennis_rating','padel_rating','squash_rating','pickleball_rating']
export function memberProfileDisplaySnapshot(profile) {
  return Object.fromEntries(fields.filter(field => Object.hasOwn(profile || {}, field)).map(field => [field, profile[field]]))
}
export function reconcileConfirmedProfile(profile, confirmation, scope) {
  return confirmation?.scope === scope && confirmation?.id === profile?.id ? { ...profile, ...confirmation.patch } : profile
}
